import React, { useContext, useEffect, useRef, useState } from "react";
import { ScreenSizeContext } from "../../context/ScreenSizeContext";
import { EmailTemplateContext } from "../../context/EmailTemplateContext";
import ColumnLayout from "./Layoutlements/ColumnLayout";
import ViewHtmlDialog from "./ViewHtmlDialog";
import { HtmlCodeExtractedContext } from "../../context/HtmlCodeExtracted";
import { GetHtmlCodeContext } from "../../context/GetHtmlCodeContex";

function Canvas({ viewHTMLCode, setViewHTMLCode, copy, setCopy, testEmail }) {
  const htmlRef = useRef();
  const { screenSize, setScreenSize, dragElementLayout, setDragElementLayout } =
    useContext(ScreenSizeContext);
  const { emailTemplate, setEmailTemplate } = useContext(EmailTemplateContext);
  const [dragOver, setDragOver] = useState(false);
  const { htmlCode, setHtmlCode, saveEmailTemplate } = useContext(
    HtmlCodeExtractedContext
  );
  const { registerGetHtmlCode } = useContext(GetHtmlCodeContext);

  const onDragOverHandle = (e) => {
    e.preventDefault();
    setDragOver(true);
  };
  const onDragLeaveHandle = (e) => {
    e.preventDefault();
    setDragOver(false);
  };
  const onDropHandle = (e) => {
    setDragOver(false);
    if (dragElementLayout?.dragLayout) {
      setEmailTemplate((prev) => [...prev, dragElementLayout?.dragLayout]);
    }
  };

  const getlayouComponent = (layout) => {
    if (layout?.type === "column") {
      return <ColumnLayout layout={layout} />;
    }
  };

  function removeString(bigString, target = "Drag Element Here") {
    return bigString.split(target).join("");
  }

  function removeImageByUrl(htmlString, targetUrl) {
    const container = document.createElement("div");
    container.innerHTML = htmlString;

    const imgs = container.querySelectorAll(`img[src="${targetUrl}"]`);

    imgs.forEach((img) => {
      img.remove(); // remove the <img> element entirely
    });

    return container.innerHTML;
  }

  const getHtmlCode = () => {
    let finalHTML = "";
    if (htmlRef.current) {
      const htmlContent = htmlRef.current.innerHTML;
      // console.log(htmlContent);
      let htmlCd = removeString(htmlContent);
      finalHTML = removeImageByUrl(
        htmlCd,
        // "https://erpapi.eduskillsfoundation.org/email_images/0173c91a-659c-44c2-bbc8-a899f27b6ac6.png"
        "https://erpapi.eduskillsfoundation.org/email_images/c1d23cfe-f92d-4833-a96f-cec6ba0398fc.jpg"
      );
      // console.log(finalHTML);
      setHtmlCode(finalHTML);
    }
    return finalHTML;
  };

  // Register with dependency array
  useEffect(() => {
    if (registerGetHtmlCode) {
      registerGetHtmlCode(getHtmlCode);
    }
  }, [registerGetHtmlCode, emailTemplate]);

  useEffect(() => {
    (viewHTMLCode || testEmail) && getHtmlCode();
  }, [viewHTMLCode, testEmail]);

  return (
    <div
      ref={htmlRef}
      style={{
        marginTop: "60px",
      }}
    >
      <table
        role="presentation"
        width="100%"
        cellSpacing="0"
        cellPadding="0"
        style={{ width: "100%" }}
      >
        <tr>
          <td align="center">
            <table
              role="presentation"
              width="100%"
              cellSpacing="0"
              cellPadding="0"
              style={{
                width: "100%",
                maxWidth: screenSize === "desktop" ? "672px" : "448px",
                backgroundColor: dragOver ? "#E9D5FF" : "#FFFFFF",
                borderRadius: "4px",
              }}
            >
              <tr>
                <td
                  style={{
                    padding: "24px",
                    width: "100%",
                  }}
                  onDragOver={onDragOverHandle}
                  onDragLeave={onDragLeaveHandle}
                  onDrop={() => onDropHandle()}
                >
                  {emailTemplate?.length > 0 ? (
                    emailTemplate.map((layout, index) => (
                      <div key={index}>{getlayouComponent(layout)}</div>
                    ))
                  ) : (
                    <h2
                      style={{
                        padding: "16px",
                        textAlign: "center",
                        backgroundColor: "#F3F4F6",
                        border: "1px dashed #9CA3AF",
                        margin: 0, // important for email clients
                      }}
                    >
                      Add Layout here
                    </h2>
                  )}
                </td>
              </tr>
            </table>

            <ViewHtmlDialog
              openDialog={!!viewHTMLCode}
              htmlCode={htmlCode}
              onClose={() => setViewHTMLCode(false)}
              copy={copy}
              setCopy={() => setCopy(false)}
            />
          </td>
        </tr>
      </table>
    </div>
  );
}

export default Canvas;
